var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"\r\n      @media all and (max-width: 600px) {\r\n        .svg-box-content { \r\n            width: 15px;\r\n            height: 9px;\r\n            margin-bottom: 20px;\r\n        }\r\n\r\n      }\r\n    "),React.createElement("path",{"d":"M2 2L15.5 15L29 2","stroke":"black","strokeWidth":"3","key":1})]);
}

ArrowDown.defaultProps = {"className":"svg-box-content","width":"21","height":"12","viewBox":"0 0 31 18","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
